import "./background.css";
import {SetupProps} from "./props";

export function Background(props: SetupProps) {
    return (
        <g className="grid-background">
            <rect x="0" y="0" width={props.setup.size * 100} height={props.setup.size * 100} />
        </g>
    );
}